import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class FileService {
  static uploadFile(file) {
    const formData = new FormData();
    formData.append("fileUpload", file, file.newName);

    const url = `${endpoints.BASE_URL}${endpoints.POST_FILE}`;

    return axios.post(url, formData).then((response) => response.data.Location);
  }

  static async deleteFile(fileUri) {
    const url = `${endpoints.BASE_URL}${endpoints.POST_FILE}`;
    return axios.delete(url, { fileUri }).then((response) => response.data);
  }

  static async getFileWithToken(filePath, token) {
    const url = `${endpoints.BASE_URL}${endpoints.POST_FILE}/findFileUrl/${filePath}`;

    return axios
      .get(url, {
        headers: {
          authorization: `Bearer ${token}`
        }
      })
      .then((response) => response.data);
  }
}

export default FileService;
